import { useEffect } from "react";
import { useTranslation } from "react-i18next";

/**
 * Keeps the document title, meta description and <html lang> in sync with the
 * selected language. Without this they stay frozen at the values in index.html.
 */
export default function DocumentMeta() {
    const { t, i18n } = useTranslation();

    useEffect(() => {
        document.title = t("pageTitle");

        const description = document.querySelector('meta[name="description"]');
        if (description) {
            description.setAttribute("content", t("pageDescription"));
        }

        document.documentElement.lang = i18n.language.startsWith("es") ? "es" : "en";
    }, [t, i18n.language]);

    return null;
}
